import activitiesTypes from "./activities.types";

export default {
  [activitiesTypes.FETCH_TIER_ACTIVITIES_SUCCESS](state, payload) {
    state.type = activitiesTypes.FETCH_TIER_ACTIVITIES_SUCCESS;
    state.data = { ...state.data, ...payload.data };
  },
  [activitiesTypes.FETCH_TIER_ACTIVITIES_FAILED](state, payload) {
    state.type = activitiesTypes.FETCH_TIER_ACTIVITIES_FAILED;
    state.error = payload.error;
  },
  [activitiesTypes.FETCH_TIER_ACTIVITIES_REQUEST](state) {
    state.type = activitiesTypes.FETCH_TIER_ACTIVITIES_REQUEST;
    state.error = "";
  },

  [activitiesTypes.FETCH_ACTION_ACTIVITIES_SUCCESS](state, payload) {
    state.type = activitiesTypes.FETCH_ACTION_ACTIVITIES_SUCCESS;
    state.data = { ...state.data, ...payload.data };
  },
  [activitiesTypes.FETCH_ACTION_ACTIVITIES_FAILED](state, payload) {
    state.type = activitiesTypes.FETCH_ACTION_ACTIVITIES_FAILED;
    state.error = payload.error;
  },
  [activitiesTypes.FETCH_ACTION_ACTIVITIES_REQUEST](state) {
    state.type = activitiesTypes.FETCH_ACTION_ACTIVITIES_REQUEST;
    state.error = "";
  }
};
